<div
  class="dialog-container"
  [class.type-alert]="type === 'alert'"
  [class.type-confirm]="type === 'confirm'"
  [class.type-info]="type === 'info'"
  [class.type-yes-no]="type === 'yesNo'"
  [class.type-yes-no-cancel]="type === 'yesNoCancel'"
  [class.type-warning]="type === 'warning'"
  [style.max-width]="maxWidthValue"
  [style.width]="widthValue">
  <div class="dialog-content">
    @if (type) {
      <div class="dialog-icon">
        <ppl-icon
          [svgIcon]="MessageIcons[type]"
          width="48px"
          height="48px"></ppl-icon>
      </div>
    }

    <div class="dialog-data">
      @if (text) {
        <div class="dialog-text">{{ text }}</div>
      }
      @if (description) {
        <div
          class="dialog-description"
          [style.white-space]="styleWhiteSpace"
          [innerHTML]="description"></div>
      }

      <ng-content></ng-content>
    </div>
  </div>

  @if (actionsTemplate) {
    <div class="dialog-actions">
      <ng-template [ngTemplateOutlet]="actionsTemplate"></ng-template>
    </div>
  }
  @if (!actionsTemplate) {
    @if (type === 'alert' || type === 'warning') {
      <div class="dialog-actions">
        @if (actionVisible) {
          <button
            type="button"
            pplButton
            [pplButtonType]="actionButtonTypeValue"
            pplButtonSmall
            pplButtonDialog
            (click)="onClose(true)">
            {{ actionLabel || intl.Proceed }}
          </button>
        }
        @if (cancelVisible) {
          <button
            pplButton
            pplButton1
            pplButtonSmall
            pplButtonDialog
            (click)="onClose(false)">
            {{ cancelLabel || intl.Cancel }}
          </button>
        }
      </div>
    }
    @if (type === 'confirm') {
      <div class="dialog-actions">
        @if (actionVisible) {
          <button
            pplButton
            [pplButtonType]="actionButtonTypeValue"
            pplButtonSmall
            pplButtonDialog
            (click)="onClose(true)">
            {{ actionLabel || intl.Confirm }}
          </button>
        }
        @if (cancelVisible) {
          <button
            pplButton
            pplButton1
            pplButtonSmall
            pplButtonDialog
            (click)="onClose(false)">
            {{ cancelLabel || intl.Cancel }}
          </button>
        }
      </div>
    }
    @if (type === 'info') {
      <div class="dialog-actions">
        <button
          type="button"
          pplButton
          [pplButtonType]="actionButtonTypeValue"
          pplButtonSmall
          pplButtonDialog
          (click)="onClose(true)">
          {{ actionLabel || intl.Continue }}
        </button>
      </div>
    }
    @if (type === 'yesNo' || type === 'yesNoCancel') {
      <div class="dialog-actions">
        <button
          pplButton
          [pplButtonType]="actionButtonTypeValue"
          pplButtonSmall
          pplButtonDialog
          (click)="dialogRef.close('Yes')">
          {{ yesLabel || intl.Yes }}
        </button>
        @if (noVisible) {
          <button
            pplButton
            [pplButtonType]="noButtonTypeValue"
            pplButtonSmall
            pplButtonDialog
            (click)="dialogRef.close('No')">
            {{ noLabel || intl.No }}
          </button>
        }
        @if (type === 'yesNoCancel') {
          <button
            pplButton
            pplButton1
            pplButtonSmall
            pplButtonDialog
            (click)="dialogRef.close('Cancel')">
            {{ cancelLabel || intl.Cancel }}
          </button>
        }
      </div>
    }
  }
</div>
